import axios from 'axios';
/*
 * Used for tenant API calls.
 * for example: get tenants users, get tenants data
 *
 * X-TENANT-ID header required for ALL calls
 */

const tenantApi = {
  setSelectedTenant(tenant) {
    axios.defaults.headers.common['X-tenant-id'] = tenant;
  },
  async getCurrentTenant() {
    const response = await axios.get('/api/tenant');
    return response.data;
  },
  /**
   *
   * @param {!object} data
   * @param {!string} data.name
   * @returns {Promise<any>}
   */
  async updateCurrentTenant(data) {
    const response = await axios.post('/api/tenant', data);
    return response.data;
  },
  async getHellos() {
    const response = await axios.get('/api/tenant/hello');
    return response.data;
  },
  async addHello(msg) {
    const response = await axios.post('/api/tenant/hello', {msg});
    return response.data;
  },
  async deleteHello(helloId) {
    const response = await axios.delete(`/api/tenant/hello/${helloId}`);
    return response.data;
  },
  async loadTenantUsers() {
    const response = await axios.get('/api/tenant/user');
    return response.data;
  },
  /**
   *
   * @param {!Object} data
   * @param {!string} data.firstName
   * @param {!string} data.lastName
   * @param {!string} data.email
   * @returns {Promise<any>}
   */
  async addNewUserToTenant(data) {
    const response = await axios.post('/api/tenant/user', {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
    });
    return response.data;
  },
  async removeUserFromTenant(userId) {
    const response = await axios.delete(`/api/tenant/user/${userId}`);
    return response.data;
  },
  async getRoles() {
    const response = await axios.get('/api/admin/tenant/roles'); // Vaihdettu admin puolelle, ei vaddi tenant idtä
    return response.data;
  },
  async addRole(subject, role) {
    const response = await axios.post(`/api/tenant/user/${subject}/role/${role}`);
    return response.data;
  },
  async deleteRole(subject, role) {
    const response = await axios.delete(`/api/tenant/user/${subject}/role/${role}`);
    return response.data;
  },
  async getTenantValues() {
    const response = await axios.get('/api/tenant/values');
    return response.data;
  },
  async createOrUpdateTenantValue(/* TenantValue */ tenantValue) {
    const response = await axios({
      url: '/api/tenant/value',
      method: 'POST',
      data: tenantValue,
    });
    return response.data;
  },
  async deleteTenantValue(/* TenantValue */ tenantValue) { // Need tenantValue.key

    const response = await axios.delete('/api/tenant/value', {
      data: tenantValue
    });
    return response.data;
  }
};

class TenantValue {
  constructor(key, value, tenantUUID, tenantId) {
    this.key = key;
    this.value = value;
    this.tenantUUID = tenantUUID;
    this.tenantId = tenantId;
  }

}

export {TenantValue}
export default tenantApi;
